<template>
  <div id="app">
    <!-- Loader -->
    <div id="page-preloader" v-if="isLoading">
      <div class="preloader-1">
        <div class="loader-text">Loading</div>
      </div>
    </div>
    <!-- Loader end -->

    <div class="page-wrapper" v-show="!isLoading">
      <HeaderComponent />
      <div class="page-content">
        <SidebarComponent />
        <!-- 渲染路由组件 -->
        <router-view />
      </div>
    </div>

    <!-- 模态框 -->
    <ModalComponent />

    <!-- 客服 Crisp 代码 -->
    <div id="crisp-chat"></div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import HeaderComponent from "./components/HeaderComponent.vue";
import SidebarComponent from "./components/SidebarComponent.vue";
import ModalComponent from "./components/ModalComponent.vue";

export default {
  name: "App",
  components: {
    HeaderComponent,
    SidebarComponent,
    ModalComponent,
  },
  setup() {
    const isLoading = ref(false);
    const route = useRoute();

    // 监听路由变化，加载动画
    watch(
      () => route.fullPath,
      () => {
        isLoading.value = true;
        setTimeout(() => {
          isLoading.value = false;
        }, 200); // 200ms 加载模拟
      }
    );

    // 加载 Crisp 客服
    onMounted(() => {
      window.$crisp = [];
      window.CRISP_WEBSITE_ID = "91bc7852-a827-4be5-a0d2-6be33c6d44aa";
      const s = document.createElement("script");
      s.src = "https://client.crisp.chat/l.js";
      s.async = 1;
      document.head.appendChild(s);
    });

    return {
      isLoading,
    };
  },
};
</script>

<style>
/* 🌟 页面整体布局 */
#app {
  position: relative;
}

/* 🗨️ Crisp 客服 */
#crisp-chat {
  position: fixed;
  bottom: 10px;
  right: 10px;
}
</style>
